import NewUserRequirementsView from './NewUserRequirementsView/NewUserRequirementsView';
// @ vendors
import React, { Component } from 'react';
import classNames from 'classnames';
import Storage from 'utilities/storage';
import { Decision } from '../jointholders/decision';
import { Initial } from './Initial';
import { Initial as InitialJH } from '../jointholders/initial';
import { Information } from '../jointholders/information';
import { HireSolidarityCardView } from 'routes/hireSolidarityCardView/hireSolidarityCardView';
import { Header } from 'components/header/header';
import { identifyCreditCardPath, validateCreditCardPath } from 'utilities/creditCard/creditCard';
import { CREDIT_CARD_PARTNERS } from 'constants/creditCard/partners';
import { DEBIT_ONG_CODE } from 'constants/products';
import { shouldRedirectToModelOnboarding } from 'utilities/modelOnboardingHelper';
import { MODEL_BANK_REDIRECTION_ONBOARDING } from 'constants/featureFlagging';
import { withRouter } from 'react-router-dom';

import('../../styles/blocks/_product.scss');

class InitialViewComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            informationHeight: true,
            initialHeight: true,
            hasLoadedProducts: false,
            hasUserReadRequirements: false,
        };

        this.changeHeight = this.changeHeight.bind(this);
        this.handleClickProcessStart = this.handleClickProcessStart.bind(this);
    }

    componentDidMount() {
        const { pathname } = this.props.location;
        if (validateCreditCardPath(pathname)) {
            const partner = identifyCreditCardPath(pathname);
            const PARTNER_ID = CREDIT_CARD_PARTNERS[partner];
            this.props.productsActions.getCreditCardProduct(PARTNER_ID);
        }
    }

    componentDidUpdate() {
        const { preLoaderActions, productsActions, partner } = this.props;

        if (partner != null && !this.state.hasLoadedProducts) {
            setTimeout(() => preLoaderActions.showPreLoader(), 500) &&
                setTimeout(() => preLoaderActions.hidePreLoader(), 1000) &&
                productsActions.getProductActivated(partner);
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ hasLoadedProducts: true });
        }
    }

    changeHeight(type) {
        if (type === 'information') {
            this.setState({
                informationHeight: false,
            });
        } else {
            this.setState({
                initialHeight: false,
            });
        }
    }

    validateHireSolidarityCard() {
        const {
            location: { pathname },
            match: {
                params: { code },
            },
            partner,
        } = this.props;
        const showhireSolidarityCardView = this.props.hireSolidarityCard.get('showhireSolidarityCardView');
        const promoCode = code && decodeURI(code).toLowerCase();
        let content = <Initial {...this.props} />;

        const isCreditCardPath = validateCreditCardPath(pathname);

        if (isCreditCardPath && partner == null) {
            content = null;
        }

        if (promoCode === DEBIT_ONG_CODE && showhireSolidarityCardView) {
            content = <HireSolidarityCardView />;
        }

        return content;
    }

    handleClickProcessStart() {
        this.setState({ hasUserReadRequirements: true });
    }

    render() {
        const { hasUserReadRequirements } = this.state;
        const { userProfile, flags } = this.props;

        if (!hasUserReadRequirements && !userProfile.isJointHolder) {
            return <NewUserRequirementsView onClickStartProcess={this.handleClickProcessStart} />;
        }

        const isModelRedirectFlagOn = flags.get(MODEL_BANK_REDIRECTION_ONBOARDING);
        const accessToken = Storage.cookies.get('accessToken');
        const { contractToken } = this.props.match.params;

        const containerClassNames = classNames({
            'animation-container':
                userProfile.isJointHolder || userProfile.isJointHolderNoClient || userProfile.jointHolderForm,
            'animation-container__joint-holder-decision':
                userProfile.isJointHolder && !userProfile.isJointHolderNoClient && !userProfile.jointHolderForm,
            'animation-container__joint-holder-information':
                userProfile.isJointHolder && userProfile.isJointHolderNoClient && !userProfile.jointHolderForm,
            'animation-container__joint-holder-initial':
                userProfile.isJointHolder && userProfile.isJointHolderNoClient && userProfile.jointHolderForm,
            'prospects-content--wizardless': !userProfile.isJointHolder,
        });

        let bigHeader = false;
        let view = this.validateHireSolidarityCard();

        if (userProfile.isJointHolder && !Storage.cookies.get('accessToken')) {
            if (!userProfile.isJointHolderNoClient && userProfile.jointHolderData) {
                bigHeader = true;
                view = <Decision />;
            } else if (!userProfile.jointHolderForm) {
                view = <Information changeHeight={this.changeHeight} />;
            } else {
                view = <InitialJH userProfile={userProfile} changeHeight={this.changeHeight} />;
            }
        } else if (userProfile.isJointHolder) {
            if (!userProfile.isJointHolderNoClient && userProfile.jointHolderData) {
                bigHeader = true;
                view = <Decision />;
            }
        }

        return (
            (shouldRedirectToModelOnboarding(accessToken, contractToken) && isModelRedirectFlagOn) || (
                <div className="prospects-content">
                    <Header bigHeader={bigHeader} />
                    <div className={containerClassNames}>{view}</div>
                </div>
            )
        );
    }
}

export default withRouter(InitialViewComponent);
